export default "__VITE_ASSET__21M83sOp__"